"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMinimalValidDeviceObject = exports.isValidAWSDeviceObject = exports.getWhyDeviceInvalid = exports.isValidDeviceObject = exports.isBasicDeviceObject = exports.isLNSResolveableDeviceObject = exports.isASFSupportingDeviceType = exports.MandatoryDeviceKeys = exports.DeviceAppCycleMode = exports.DeviceState = exports.DeviceProvisioningState = void 0;
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
var DeviceProvisioningState;
(function (DeviceProvisioningState) {
    DeviceProvisioningState["NOT_INVENTORIZED"] = "NOT_INVENTORIZED";
    DeviceProvisioningState["INVENTORY"] = "INVENTORY";
    DeviceProvisioningState["ALLOCATED"] = "ALLOCATED";
})(DeviceProvisioningState || (exports.DeviceProvisioningState = DeviceProvisioningState = {}));
var DeviceState;
(function (DeviceState) {
    DeviceState["UNKNOWN"] = "UNKNOWN";
    DeviceState["MANUFACTURING"] = "MANUFACTURING";
    DeviceState["COMMISSIONED"] = "COMMISSIONED";
    DeviceState["DECOMMISSONED"] = "DECOMMISSONED";
    DeviceState["SUSPENDED"] = "SUSPENDED";
    DeviceState["CALIBRATED"] = "CALIBRATED";
    DeviceState["TRANSITIN"] = "TRANSITIN";
    DeviceState["TRANSITOUT"] = "TRANSITOUT";
    DeviceState["WITHCUSTOMER"] = "WITHCUSTOMER";
    DeviceState["WITHENGINEER"] = "WITHENGINEER";
    DeviceState["INVENTORY"] = "INVENTORY";
    DeviceState["ORDEREDCUSTOMER"] = "ORDEREDCUSTOMER";
    DeviceState["ORDERED"] = "ORDERED";
    DeviceState["RETIRED"] = "RETIRED";
    DeviceState["JOINED"] = "JOINED";
})(DeviceState || (exports.DeviceState = DeviceState = {}));
/**
 * When changing mode, **always** send a downlink alongside updating the {@link Device | `Device`} object!
 */
var DeviceAppCycleMode;
(function (DeviceAppCycleMode) {
    /** Default, with user-configurable app cycle time, commonly defaults to 15 minutes */
    DeviceAppCycleMode["Normal"] = "normal";
    /** Alternate, with non-configurable 1-minute app cycle time */
    DeviceAppCycleMode["Rapid Response Mode"] = "rapid";
})(DeviceAppCycleMode || (exports.DeviceAppCycleMode = DeviceAppCycleMode = {}));
exports.MandatoryDeviceKeys = [
    'eui',
    'appID',
    'appKey',
    'networkKey',
    'deviceId',
    'deviceType',
    'appEui',
    'firmwareLevel',
    'regionalPlan',
];
const isASFSupportingDeviceType = (vob) => {
    return (0, exports.isValidDeviceObject)(vob) && (0, iotv_v3_types_1.deviceSupportsIoTVFeature)({ device: vob, feature: 'ASF' });
};
exports.isASFSupportingDeviceType = isASFSupportingDeviceType;
/** type check for LNS resolution and downlink sending, to deal with legacy LNS devices where appKey, appEui are not recorded */
const isLNSResolveableDeviceObject = (vob) => {
    const { eui, networkKey, deviceId, appID } = vob ?? {};
    return !!((0, iotv_v3_types_1.isVOBofType)('Device', vob) && eui === vob.id && appID && networkKey);
};
exports.isLNSResolveableDeviceObject = isLNSResolveableDeviceObject;
const typecheck = { id: '', pk: '', sk: '', type: 'Device', eui: '', networkKey: iotv_v3_types_1.Networks.Interceptor, deviceType: iotv_v3_types_1.DeviceTypes.AgriTel };
/** returns boolen indicating the device has basic attributes required for network processsing
 * This is used where device have been discovered eg on a public network and the provisioning keys are not available.
 * Checks on objects attributes: eui,  networkKey or deviceId, deviceType
 * Note state is no longer mandatory, it is only required for state management.
 */
const isBasicDeviceObject = (vob) => {
    const { eui, networkKey, deviceType } = vob ?? {};
    return !!((0, iotv_v3_types_1.isVOBofType)('Device', vob) && eui === vob.id && networkKey && deviceType);
};
exports.isBasicDeviceObject = isBasicDeviceObject;
/** returns boolen indicating the device has all the key attributes required for system processing.
 * Checks on objects attributes: eui, appKey, networkKey or deviceId, deviceType
 * Note state is no longer mandatory, it is only required for state management.
 */
const isValidDeviceObject = (vob) => {
    const { eui, appKey, networkKey, deviceId, deviceType, appEui, appID } = vob ?? {};
    return !!((0, iotv_v3_types_1.isValidBusinessObject)(vob) && eui === vob.id && appKey && appEui && networkKey && deviceType);
};
exports.isValidDeviceObject = isValidDeviceObject;
/* Companion fn to the one above that explains why your device is invalid */
const getWhyDeviceInvalid = (vob) => {
    const { eui, appKey, networkKey, deviceId, deviceType, appEui, appID } = vob ?? {};
    const valid = (0, iotv_v3_types_1.isValidBusinessObject)(vob);
    let problems = [];
    if (eui !== vob.id) {
        problems.push(`Device EUI (${eui}) != Device Id (${vob.id})`);
    }
    if (!appKey) {
        problems.push('No appkey');
    }
    if (!appEui) {
        problems.push('No app EUI');
    }
    if (!networkKey) {
        problems.push('No network key');
    }
    if (!deviceType) {
        problems.push('No device type');
    }
    return { valid, problems, vob };
};
exports.getWhyDeviceInvalid = getWhyDeviceInvalid;
/** Checks if the region is valid and if the network key is AWS */
const isValidAWSDeviceObject = (vob) => {
    return (0, exports.isValidDeviceObject)(vob) && (0, iotv_v3_types_1.isValidRFRegion)(vob.regionalPlan) && vob.networkKey === iotv_v3_types_1.Networks.AWS_LPWAN;
};
exports.isValidAWSDeviceObject = isValidAWSDeviceObject;
/** returns a stripped device object which can be used to retrieve the full current version and has all necessary keys for system processing
 * used in DeviceControlTransaction to minimize storage.
 */
const getMinimalValidDeviceObject = (item) => {
    if ((0, exports.isValidDeviceObject)(item)) {
        return (0, iotv_v3_types_1.stripNode)(item, exports.MandatoryDeviceKeys);
    }
    return null;
};
exports.getMinimalValidDeviceObject = getMinimalValidDeviceObject;
